
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpM = createBreakpoint('m');

export const mainCls = 'sdr-picture';

export default {
  [mainCls]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  [`${mainCls}__img`]: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    objectPosition: 'center center',
    transform: 'translate(-50%, -50%)',
    [brpM]: {
      top: 0,
      left: 0,
      height: '100%',
      transform: 'translate(0, 0)',
    },
  },
};
